import React, { useCallback, useEffect, useState } from "react";
import { useApi } from "../../hooks/api";
import { useGlobal } from "../../hooks/global";
import { ITable } from "../../components/TableList";
import { IoAddCircleOutline } from "react-icons/io5";
import { PageList } from "../../components/PageList";
import { getFilterFields } from "../../utils/filterFields";
import { setUpConsultation } from "../../services/generalServices";
import { IActions, IFilters, userProps } from "../../interfaces/index";
import { ModalUser } from "../../components/Modals/ModalUser";
import { IPermissionsTypes } from "../../utils/permissions";
import { FaEdit } from "react-icons/fa";
import { secondary } from "../../theme";
import { MdDelete } from "react-icons/md";
import { getUserTypeBadge } from "../../utils/columnsTables";

const initialFilters: IFilters[] = [getFilterFields("user_type_id")];

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "surname",
      name: "Apelido",
      limitWidth: true,
      style: {},
      styleContent: { fontSize: 16, fontWeight: 600 },
    },
    {
      attr: "email",
      name: "Email",
      limitWidth: true,
      style: {},
      styleContent: {},
    },
    {
      attr: "type",
      name: "Tipo",
      style: { textAlign: "center" },
      styleContent: { textAlign: "center" },
    },
  ],
};

export const UsersList: React.FC = () => {
  const { user, api } = useApi();
  const { theme, paginationLimit, notify } = useGlobal();

  const [atualPage, setAtualPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [openModal, setOpenModal] = useState(false);
  const [numOfPersons, setNumOfPersons] = useState(0);
  const [updatedAt, setUpdatedAt] = useState(new Date());
  const [loadingPersons, setLoadingPersons] = useState(true);
  const [searchString, setSearchString] = useState<string>("");
  const [numberOfPages, setNumberOfPages] = useState<number>(1);
  const [userSelected, setUserSelected] = useState<userProps | null>(null);
  const [table, setTable] = useState<ITable>(initialTable);

  const changeStatusUser = useCallback(
    async (userId: string, old_status: boolean) => {
      const new_active = !old_status;

      setTable((atual) => {
        const new_table = { ...atual };
        const pos = new_table.data.findIndex((d) => d?.this.id === userId);
        if (pos !== -1) new_table.data[pos].this.active = new_active;
        return { ...new_table };
      });

      try {
        await api.put(`/users/${userId}`, { active: new_active });
        notify("Status do usuário atualizado com sucesso.", "success");
      } catch (err) {
        notify("Erro ao alterar status do usuário.", "error");
        setTable((atual) => {
          const new_table = { ...atual };
          const pos = new_table.data.findIndex((d) => d?.this.id === userId);
          if (pos !== -1) new_table.data[pos].this.active = old_status;
          return { ...new_table };
        });
      }
    },
    []
  );

  const selectUser = useCallback((customer: userProps) => {
    setUserSelected({ ...customer });
    setOpenModal(true);
  }, []);

  const searchUsers = useCallback(
    async (page, _filters = null) => {
      setAtualPage(page);
      setLoadingPersons(true);
      try {
        const filters_obj = _filters
          ? _filters
          : { ...filters, search: searchString };

        let string = setUpConsultation(filters_obj);
        let url = `/users?page=${page}&limit=${paginationLimit}&${string}`;

        const result = await api.get(url);
        const new_users = result.data.data as userProps[];
        setTable((atual) => {
          const new_table = { ...atual };
          new_table.data = [];
          new_users.forEach((user) => {
            new_table.data.push({
              id: user.id,
              surname: user.surname,
              email: user.email,
              type: getUserTypeBadge({ theme, type: user.user_type.name })
            /*   (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 5,
                    justifyContent: "center",
                  }}
                >
                  <div style={{ display: "flex" }} key={user?.user_type.name}>
                    <div
                      style={{
                        padding: 5,
                        whiteSpace: "nowrap",
                        display: "flex",
                        paddingLeft: 7,
                        paddingRight: 7,
                        borderRadius: 3,
                        background: '#2d1b67',
                        color: "#FFF",
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      <CgHome size={16} style={{ marginTop: 0.72, marginRight: 3 }} /> {user?.user_type.name}
                    </div>
                  </div>
                   <div style={{ display: "flex", justifyContent: "center" }}>
                    <div
                      style={{
                        padding: 3,
                        justifyContent: "center",
                        whiteSpace: "nowrap",
                        display: "flex",
                        paddingLeft: 5,
                        paddingRight: 5,
                        borderRadius: 3,
                      }}
                    >
                      {user.user_type.name}
                    </div>
                  </div>
                </div >
              ),  */,
              this: user,
            });
          });
          return { ...new_table };
        });

        setNumOfPersons(result.data.count);
        setNumberOfPages(Math.ceil(result.data.count / paginationLimit));
        setUpdatedAt(new Date());
      } catch (err) {
        notify("Erro na busca pelos usuários!", "error");
      }
      setLoadingPersons(false);
    },
    [user, filters, searchString, theme]
  );

  const handleConfirmDeleteCheckIn = useCallback(
    async (id: string) => {
      setLoadingPersons(true);

      try {
        await api.put(`users/delete/${id}`);

        notify("Usuário excluído com sucesso!", "success");

        await searchUsers(1);
      } catch (error: any) {
        const default_message = "Erro ao excluir user!";

        const message = error.response?.data?.detail ?? default_message;
        notify(message, message === default_message ? "error" : "alert");
      }

      setLoadingPersons(false);
    },
    [searchUsers]
  );

  const alertDelete = useCallback(
    async (item: any): Promise<void> => {

      const result = window.confirm(
        "Tem certeza que deseja excluir o usuário: " +
        item.surname.toUpperCase()
      );

      if (result) handleConfirmDeleteCheckIn(item.id as unknown as string);
    },
    [handleConfirmDeleteCheckIn]
  );


  const openModalNewUser = useCallback(() => {
    setUserSelected(null);
    setOpenModal(true);
  }, []);

  const handleAction = (action_id: string) => {
    if (action_id === "new_item") openModalNewUser();
  };

  const actionsInitial: IActions[] = [
    {
      main_option: { text: "Novo Usuário", id: "new_item" },
      className: "new_item",
      icon: <IoAddCircleOutline size={20} className="new_item" />,
      options: [],
      type: "solid",
      permissions: ["USERS-CREATE"],
    },
  ];

  const onSaveUser = useCallback(() => {
    setOpenModal(false);
    searchUsers(1);
  }, [user, filters, searchString]);

  const listActions = [
    {
      title: "Editar",
      onClick: (user: userProps) => selectUser(user),
      icon: <FaEdit color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes("USERS-UPDATE" as IPermissionsTypes),
    },
    {
      title: "Excluir",
      onClick: (user: userProps) => alertDelete(user),
      icon: <MdDelete color={secondary[theme]} size={20} />,
      disabled: () => !user.user_type.permissions.includes("USERS-DELETE" as IPermissionsTypes),
    },
    // {
    //   title: "Redefinir Senha",
    //   onClick: (user: userProps) => selectUser(user),
    //   icon: <RiLockPasswordLine color={secondary[theme]} size={20} />,
    //   disabled: () => !user.user_type.permissions.includes("USERS-UPDATE" as IPermissionsTypes),
    // },
    // {
    //   title: "Remover",
    //   onClick: (user: userProps) => selectUser(user),
    //   icon: <MdDelete color={secondary[theme]} size={20} />,
    //   disabled: () => !user.user_type.permissions.includes("USERS-UPDATE" as IPermissionsTypes),
    // },
  ];

  useEffect(() => {
    searchUsers(1);
  }, [theme]);

  return (
    <PageList
      updatedAt={updatedAt}
      loading={loadingPersons}
      setLoading={setLoadingPersons}
      numberOfItems={numOfPersons}
      actions={actionsInitial}
      onClickOption={handleAction}
      textHeader="Usuários"
      textItems="usuários encontrados"
      text_loading={"Buscando Usuários"}
      text_empty={"Nenhum usuário encontrado"}
      theme={theme}
      initialFilters={initialFilters}
      onChangeFilters={setFilters}
      table={table}
      listActions={listActions}
      moduleName="users"
      pages={numberOfPages}
      page={atualPage}
      search={searchUsers}
      onChangeSearch={setSearchString}
      have_status={user.user_type.permissions.includes(
        "USERS-UPDATE" as IPermissionsTypes
      )}
      status_action={changeStatusUser}
    >
      {openModal && (
        <ModalUser
          onCancel={() => setOpenModal(false)}
          onSave={onSaveUser}
          openModal={openModal}
          backgroundVisible={false}
          defaultId={userSelected?.id}
        />
      )}
    </PageList>
  );
};
